import React from "react";
import { Spin } from "antd";

/**
 * Shared "the form is loading" reassurance — shown both while the lazy panel
 * chunk loads (BookNowButton's Suspense fallback) and while the Stripe Payment
 * Element mounts (BookingPaymentPanel's not-ready state). The wording makes it
 * unmistakable that the FORM is loading, not that a payment is being taken.
 */
const BookingPaymentLoading: React.FC = () => (
  <div style={{ textAlign: "center", padding: "20px 0" }}>
    <Spin />
    <div
      style={{
        marginTop: 8,
        fontSize: 13,
        color: "var(--color-text-muted)",
      }}
    >
      Loading payment methods…
    </div>
  </div>
);

export default BookingPaymentLoading;
